document.addEventListener('alpine:init', () => {
  Alpine.store('reset', () => {
    let url = new URL(window.location.href);
    url.searchParams.delete('filter.p.tag');
    url.searchParams.delete('filter.p.vendor');
    url.searchParams.delete('page');

    Alpine.store('brand').value = [];
    Alpine.store('category').tags = [];
    Alpine.store('loadMore').page = 1;

    window.history.pushState(window.history.state, '', url.href);
    fetch(`${url.pathname}${url.search}`)
      .then((response) => response.text())
      .then((data) => {
        let html = document.createElement('div');
        html.innerHTML = data;

        document.querySelector('#collection-hero').innerHTML = html.querySelector('#collection-hero').innerHTML;

        document.querySelector('div#collection-filters').innerHTML =
          html.querySelector('div#collection-filters').innerHTML;
        document.querySelector('div#brand-filters').innerHTML = html.querySelector('div#brand-filters').innerHTML;
        document.querySelector('section.section_product').innerHTML =
          html.querySelector('section.section_product').innerHTML;
      });
  });

  Alpine.store('sort', {
    value: '',
    set(newValue) {
      this.value = newValue;
      let url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      Alpine.store('loadMore').page = 1;
      window.history.pushState(window.history.state, '', url.href);
      fetch(`${url.pathname}${url.search}`)
        .then((response) => response.text())
        .then((data) => {
          let html = document.createElement('div');
          html.innerHTML = data;
          document.querySelector('section.section_product').innerHTML =
            html.querySelector('section.section_product').innerHTML;
        });
    },
  });

  Alpine.store('brand', {
    value: [],
    basePath: '',
    init() {
      let url = new URL(window.location.href);
      this.value = url.searchParams.getAll('filter.p.vendor');
    },
    set(newValue) {
      const index = this.value.indexOf(newValue);
      if (index !== -1) {
        this.value.splice(index, 1);
      } else {
        this.value.push(newValue);
      }
      this.update();
    },
    update() {
      let url = new URL(window.location.href);
      url.searchParams.delete('filter.p.vendor');
      if (url.searchParams.get('page') != null) {
        url.searchParams.set('page', '1');
        Alpine.store('loadMore').page = 1;
      }
      this.value.forEach((vendor) => {
        url.searchParams.append('filter.p.vendor', vendor);
      });

      window.history.pushState(window.history.state, '', url.href);
      fetch(`${url.pathname}${url.search}`)
        .then((response) => response.text())
        .then((data) => {
          let html = document.createElement('div');
          html.innerHTML = data;

          if (html.querySelector('section.section_product') == null) {
            document.querySelector('div.filters_empty').classList.remove('hide');
            document.querySelector('section.section_product').classList.add('hide');
            return;
          }
          document.querySelector('div.filters_empty').classList.add('hide');
          document.querySelector('section.section_product').classList.remove('hide');

          document.querySelector('section.section_product').innerHTML =
            html.querySelector('section.section_product').innerHTML;
        });
    },
  });

  Alpine.store('category', {
    value: '',
    basePath: '',
    tags: [],
    init() {
      let url = new URL(window.location.href);
      let paths = url.pathname.split('/');
      this.value = paths[paths.length - 1];
      this.basePath = paths.slice(0, paths.length - 1).join('/');
      this.tags = url.searchParams.getAll('filter.p.tag');
    },
    set(newValue, newValueHandle) {
      if (this.value === 'all') {
        this.value = newValueHandle;
      } else {
        if (this.tags.includes(newValue)) {
          this.tags = this.tags.filter((tag) => tag !== newValue);
        } else {
          this.tags.push(newValue);
        }
      }
      this.update();
    },
    update() {
      let url = new URL(window.location.href);
      url.pathname = `${this.basePath}/${this.value}`;
      url.searchParams.delete('filter.p.tag');
      this.tags.forEach((tag) => {
        url.searchParams.append('filter.p.tag', tag);
      });
      url.searchParams.delete('page');
      url.searchParams.delete('filter.p.vendor');

      Alpine.store('brand').value = [];
      Alpine.store('loadMore').page = 1;

      window.history.pushState(window.history.state, '', url.href);
      fetch(`${url.pathname}${url.search}`)
        .then((response) => response.text())
        .then((data) => {
          let html = document.createElement('div');
          html.innerHTML = data;

          document.querySelector('#collection-hero').innerHTML = html.querySelector('#collection-hero').innerHTML;

          document.querySelector('div#collection-filters').innerHTML =
            html.querySelector('div#collection-filters').innerHTML;
          document.querySelector('div#brand-filters').innerHTML = html.querySelector('div#brand-filters').innerHTML;

          if (html.querySelector('section.section_product') == null) {
            document.querySelector('div.filters_empty').classList.remove('hide');
            document.querySelector('section.section_product').classList.add('hide');
            return;
          }
          document.querySelector('div.filters_empty').classList.add('hide');
          document.querySelector('section.section_product').classList.remove('hide');

          document.querySelector('section.section_product').innerHTML =
            html.querySelector('section.section_product').innerHTML;
        });
    },
  });

  Alpine.store('loadMore', {
    page: 1,
    init() {
      let url = new URL(window.location.href);
      this.page = parseInt(url.searchParams.get('page') ?? 1);
      this.setup();
    },
    setup() {
      let page = this.page;
      while (page > 1) {
        page = page - 1;
        let url = new URL(window.location.href);
        url.searchParams.set('page', page);

        fetch(`${url.pathname}${url.search}`)
          .then((response) => response.text())
          .then((data) => {
            let html = document.createElement('div');
            html.innerHTML = data;
            document
              .querySelector('div.w-layout-grid.product_list')
              .prepend(...html.querySelector('div.w-layout-grid.product_list').children);
          });
      }
    },
    loadMore() {
      this.page += 1;
      let url = new URL(window.location.href);
      url.searchParams.set('page', this.page);

      window.history.pushState(window.history.state, '', url.href);
      fetch(`${url.pathname}${url.search}`)
        .then((response) => response.text())
        .then((data) => {
          let html = document.createElement('div');
          html.innerHTML = data;
          if (html.querySelector('div.load-more-button') == null) {
            document.querySelector('div.load-more-button').remove();
          }
          document
            .querySelector('div.w-layout-grid.product_list')
            .append(...html.querySelector('div.w-layout-grid.product_list').children);
        });
    },
  });

  Alpine.store('isListView', false);
});
